module.exports = __webpack_public_path__ + "img/sample_img_intro_04.89ac47d4.png";